<template>
  <ul class="menu" ref="menu">
    <li class="m1" ref="m1">
      <router-link v-if="!mobile" :to="{name: 'introTeam'}" class="idx" @click.native="toggleMenu">오늘하루치과 소개</router-link>
      <a v-else class="idx" @click.stop="openSubMenu('m1')">오늘하루치과 소개</a>
      <div class="submenu" v-if="toggle">
        <ul>
          <li class="sm1">
            <router-link :to="{name:'introTeam'}" @click.native="toggleMenu"><span>의료진소개</span></router-link>
          </li>
          <li class="sm2">
            <router-link :to="{name:'introGear'}" @click.native="toggleMenu"><span>디지털장비</span></router-link>
          </li>
          <li class="sm3">
            <router-link :to="{name:'introGallery'}" @click.native="toggleMenu"><span>치과 둘러보기</span></router-link>
          </li>
          <li class="sm4">
            <router-link :to="{name:'introLocation'}" @click.native="toggleMenu"><span>위치 및 진료안내</span></router-link>
          </li>
        </ul>
      </div>
    </li>
    <li class="m2" ref="m2">
      <a v-if="!mobile" href="https://booking.naver.com/booking/13/bizes/250352?area=ple" target="_blank" class="idx">상담 진행</a>
      <a v-else class="idx"  @click.stop="openSubMenu('m2')">상담 진행</a>
      <div class="submenu" v-if="toggle">
        <ul>
          <li class="sm1">
            <a href="https://pf.kakao.com/_KPMRxd" target="_blank" @click.native="toggleMenu"><span>빠른 상담 요청</span></a>
          </li>
          <li class="sm2"><a href="https://booking.naver.com/booking/13/bizes/250352?area=ple"
                             target="_blank" @click.native="toggleMenu"><span>방문 상담 예약</span></a></li>
          <li class="sm3">
            <router-link :to="{name:'counselModel'}" @click.native="toggleMenu">
              <span>오늘하루치과<br />모델 지원</span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>
    <li class="m3" ref="m3">
      <router-link v-if="!mobile" :to="{name: 'mediaColumnList'}" class="idx" @click.native="toggleMenu">미디어</router-link>
      <a v-else class="idx" @click.stop="openSubMenu('m3')">미디어</a>
      <div class="submenu" v-if="toggle">
        <ul>
          <li class="sm1">
            <router-link :to="{name:'mediaColumnList'}" @click.native="toggleMenu"><span>오늘하루 컬럼</span></router-link>
          </li>
          <li class="sm2">
            <router-link :to="{name:'mediaCaseList'}" @click.native="toggleMenu"><span>치료 케이스</span></router-link>
          </li>
          <li class="sm3">
            <router-link :to="{name:'mediaNewsList'}" @click.native="toggleMenu"><span>뉴스 보도자료</span></router-link>
          </li>
          <li class="sm4">
            <router-link :to="{name:'mediaVisitorList'}" @click.native="toggleMenu"><span>특별한 방문</span></router-link>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'OneDayHeaderNav',
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      toggle: true,
    };
  },
  methods: {
    toggleMenu() {
      this.toggle = false;

      this.$emit('close');
      if (this.mobile) {
        this.$refs.m1.classList.remove('on');
        this.$refs.m2.classList.remove('on');
        this.$refs.m3.classList.remove('on');
      }

      setTimeout(() => { this.toggle = true; }, 300);
    },
    openSubMenu(ref, close = false) {
      console.log(close);
      this.$refs[ref].classList.toggle('on');
    },
  },
};
</script>

<style scoped>

</style>
